import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// CRA dev overlay bazen (özellikle animasyon/transition + ResizeObserver) için
// "ResizeObserver loop completed with undelivered notifications." hatasını yanlış alarm olarak gösterebiliyor.
// Bu sadece development ortamında bu spesifik mesajı susturur.
if (process.env.NODE_ENV === 'development') {
  const isResizeObserverLoopError = (message) =>
    typeof message === 'string' &&
    (message.includes('ResizeObserver loop completed') ||
      message.includes('ResizeObserver loop limit exceeded'));

  window.addEventListener('error', (e) => {
    if (isResizeObserverLoopError(e?.message)) {
      e.stopImmediatePropagation();
    }
  });

  const originalConsoleError = console.error;
  // eslint-disable-next-line no-console
  console.error = (...args) => {
    if (isResizeObserverLoopError(args?.[0])) return;
    originalConsoleError(...args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
const app = <App />;

// StrictMode bazı kombinasyonlarda (özellikle animasyon/ölçüm mekanizmaları) dev ortamında
// "ResizeObserver loop completed..." overlay'ini tetikleyebiliyor. Dev'de kapatıp prod'da açık bırakıyoruz.
root.render(process.env.NODE_ENV === 'development' ? app : <React.StrictMode>{app}</React.StrictMode>);

